import { FormInstance } from "antd/es/form";
import { Guid } from "guid-typescript";
import moment from "moment";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IMasrafForm_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IMasrafForm_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  UcusSirketleri: any[];
  UcusSirketleri_dummy: any[];
  SelectMasrafTmp: any[];
  SelectMasrafTmp_dummy: any[];
  ParaBirimiListe: any[];
  ParaBirimiListe_dummy: any[];
  MasrafCesidiSelectAll: any[];
  MasrafCesidiSelectAll_dummy: any[];
  SetValueOf: any;
  SetValueOf_dummy: any;
  MasrafTmpDefaultDeger: any[];
  MasrafTmpDefaultDeger_dummy: any[];
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  ParseIntoTable: any[];
  ParseIntoTable_dummy: any[];
  UploadFile: any[];
  UploadFile_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  NewGuid: Guid;
  NewGuid_dummy: Guid;
  SaveRecord_1: number;
  SaveRecord_1_dummy: number;
  Concat: string;
  Concat_dummy: string;
  ForEach3: UploadFileResponse;
  ForEach3_dummy: UploadFileResponse;
  DosyaGetir: any[];
  DosyaGetir_dummy: any[];
  ChangeVisibilityOf: string;
  ChangeVisibilityOf_dummy: string;
  DownloadFile: any;
  DownloadFile_dummy: any;
  RemoveString: string;
  RemoveString_dummy: string;
  GoBack: any;
  GoBack_dummy: any;
  ParseIntoMasraf: any;
  ParseIntoMasraf_dummy: any;
  SaveRecord_2: number;
  SaveRecord_2_dummy: number;
  SaveRecord_3: number;
  SaveRecord_3_dummy: number;
  MasrafTmpToplamGuncelle: number;
  MasrafTmpToplamGuncelle_dummy: number;
  isComp524940Visible: "visible" | "hidden";
  isComp2849291Enabled: "enabled" | "disabled";
}

export class MasrafForm_ScreenBase extends React.PureComponent<
  IMasrafForm_ScreenProps,
  any
> {
  masrafform_6966972_value_kuikaSelectBoxRef: React.RefObject<any>;
  masrafform_2912554_value_kuikaSelectBoxRef: React.RefObject<any>;
  masrafform_87024_value_kuikaTableRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "5c798f4c-ff0b-45b9-883e-1f5f1c70f85e",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 796540, PropertyName: "value", Value: "Masraf Kayıt" },
        { Id: 9450, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 9231482, PropertyName: "value", Value: "Sıra No" },
        { Id: 2849291, PropertyName: "placeholder", Value: "15" },
        { Id: 2645410, PropertyName: "value", Value: "Şirketler" },
        { Id: 2496347, PropertyName: "placeholder", Value: "Seçiniz..." },
        { Id: 9474449, PropertyName: "value", Value: "Masraf Çeşidi" },
        { Id: 6966972, PropertyName: "placeholder", Value: "Seçiniz..." },
        { Id: 2970199, PropertyName: "value", Value: "Tutar" },
        { Id: 2976536, PropertyName: "placeholder", Value: "15" },
        { Id: 7857515, PropertyName: "value", Value: "PBr" },
        { Id: 2912554, PropertyName: "placeholder", Value: "Seçiniz..." },
        { Id: 7556242, PropertyName: "value", Value: "Açıklama" },
        { Id: 1620778, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 832826, PropertyName: "value", Value: "Dosyalar" },
        { Id: 672761, PropertyName: "label", Value: "Yükle" },
        { Id: 736371, PropertyName: "title", Value: "Dosya" },
        { Id: 135322, PropertyName: "value", Value: "[datafield:ad]" },
        { Id: 792946, PropertyName: "label", Value: "Göster" },
        { Id: 280193, PropertyName: "label", Value: "İndir" },
        { Id: 740588, PropertyName: "label", Value: "Kaldır" },
        { Id: 262374, PropertyName: "label", Value: "Vazgeç" },
        { Id: 9544, PropertyName: "label", Value: "Kaydet" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  ForEach3: any[];

  constructor(props) {
    super(props);
    this.masrafform_9450_value_kuikaTextInputRef = React.createRef();
    this.masrafform_6966972_value_kuikaSelectBoxRef = React.createRef();
    this.masrafform_2912554_value_kuikaSelectBoxRef = React.createRef();
    this.masrafform_87024_value_kuikaTableRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      TriggerEvent: "",
      UcusSirketleri: [],
      SelectMasrafTmp: [],
      ParaBirimiListe: [],
      MasrafCesidiSelectAll: [],
      SetValueOf: "",
      IfThenElse: false,
      ParseIntoTable: [],
      UploadFile: [],
      ForEach: false,
      DosyaGetir: [],
      ChangeVisibilityOf: "",
      DownloadFile: "",
      RemoveString: "",
      GoBack: "",
      ParseIntoMasraf: "",
      SaveRecord_2: 0,
      SaveRecord_3: 0,
      MasrafTmpToplamGuncelle: 0,
      isComp524940Visible: "hidden",
      isComp2849291Enabled: "disabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("masrafform", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.MasrafFormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("masrafform", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("masrafform", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.MasrafFormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      masrafform_2849291_value: undefined,
      masrafform_6966972_value:
        this.state.SelectMasrafTmp?.at?.(0)?.masrafKodu ?? undefined,
      masrafform_2976536_value:
        this.state.SelectMasrafTmp?.at?.(0)?.tutar ?? undefined,
      masrafform_2912554_value:
        this.state.SelectMasrafTmp?.at?.(0)?.pBr ?? undefined,
      masrafform_1620778_value:
        this.state.SelectMasrafTmp?.at?.(0)?.aciklama ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  MasrafFormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      UcusNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UcusNo ?? this.props.screenInputs.ucusno,
        "number"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      EditId_1: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.EditId ?? this.props.screenInputs.editid,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafForm/MasrafFormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.UcusSirketleri = result?.data.ucusSirketleri;

    formVars.masrafform_2496347_options = stateVars.UcusSirketleri;
    stateVars.SelectMasrafTmp = result?.data.selectMasrafTmp;
    formVars.masrafform_6966972_value =
      stateVars.SelectMasrafTmp !== undefined
        ? stateVars.SelectMasrafTmp?.length > 0
          ? stateVars.SelectMasrafTmp[0].masrafKodu
          : null
        : this.state.SelectMasrafTmp?.length > 0
        ? this.state.SelectMasrafTmp[0].masrafKodu
        : null;
    formVars.masrafform_6966972_options = stateVars.MasrafCesidiSelectAll;
    formVars.masrafform_2976536_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectMasrafTmp !== undefined
        ? stateVars.SelectMasrafTmp?.length > 0
          ? stateVars.SelectMasrafTmp[0].tutar
          : null
        : this.state.SelectMasrafTmp?.length > 0
        ? this.state.SelectMasrafTmp[0].tutar
        : null
    );
    formVars.masrafform_2912554_value =
      stateVars.SelectMasrafTmp !== undefined
        ? stateVars.SelectMasrafTmp?.length > 0
          ? stateVars.SelectMasrafTmp[0].pBr
          : null
        : this.state.SelectMasrafTmp?.length > 0
        ? this.state.SelectMasrafTmp[0].pBr
        : null;
    formVars.masrafform_2912554_options = stateVars.ParaBirimiListe;
    formVars.masrafform_1620778_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectMasrafTmp !== undefined
        ? stateVars.SelectMasrafTmp?.length > 0
          ? stateVars.SelectMasrafTmp[0].aciklama
          : null
        : this.state.SelectMasrafTmp?.length > 0
        ? this.state.SelectMasrafTmp[0].aciklama
        : null
    );
    stateVars.ParaBirimiListe = result?.data.paraBirimiListe;

    formVars.masrafform_2912554_value =
      stateVars.SelectMasrafTmp !== undefined
        ? stateVars.SelectMasrafTmp?.length > 0
          ? stateVars.SelectMasrafTmp[0].pBr
          : null
        : this.state.SelectMasrafTmp?.length > 0
        ? this.state.SelectMasrafTmp[0].pBr
        : null;
    formVars.masrafform_2912554_options = stateVars.ParaBirimiListe;
    stateVars.MasrafCesidiSelectAll = result?.data.masrafCesidiSelectAll;

    formVars.masrafform_6966972_value =
      stateVars.SelectMasrafTmp !== undefined
        ? stateVars.SelectMasrafTmp?.length > 0
          ? stateVars.SelectMasrafTmp[0].masrafKodu
          : null
        : this.state.SelectMasrafTmp?.length > 0
        ? this.state.SelectMasrafTmp[0].masrafKodu
        : null;
    formVars.masrafform_6966972_options = stateVars.MasrafCesidiSelectAll;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masrafform_2849291_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.SelectMasrafTmp !== undefined
          ? stateVars.SelectMasrafTmp?.length > 0
            ? stateVars.SelectMasrafTmp[0].siraNo
            : null
          : this.state.SelectMasrafTmp?.length > 0
          ? this.state.SelectMasrafTmp[0].siraNo
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masrafform_2496347_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.SelectMasrafTmp !== undefined
          ? stateVars.SelectMasrafTmp?.length > 0
            ? stateVars.SelectMasrafTmp[0].sirketler
            : null
          : this.state.SelectMasrafTmp?.length > 0
          ? this.state.SelectMasrafTmp[0].sirketler
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormPageInit2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  MasrafFormPageInit_if2 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.EditId ?? this.props.screenInputs.editid,
        "Guid"
      ),
      UcusNo_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.UcusNo ?? this.props.screenInputs.ucusno,
        "number"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafForm/MasrafFormPageInit_if2",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.MasrafTmpDefaultDeger = result?.data.masrafTmpDefaultDeger;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormPageInit_if21_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormPageInit_if21_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masrafform_2849291_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.MasrafTmpDefaultDeger !== undefined
          ? stateVars.MasrafTmpDefaultDeger?.length > 0
            ? stateVars.MasrafTmpDefaultDeger[0].siraNo
            : null
          : this.state.MasrafTmpDefaultDeger?.length > 0
          ? this.state.MasrafTmpDefaultDeger[0].siraNo
          : null
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masrafform_2496347_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.MasrafTmpDefaultDeger !== undefined
          ? stateVars.MasrafTmpDefaultDeger?.length > 0
            ? stateVars.MasrafTmpDefaultDeger[0].sirketler
            : null
          : this.state.MasrafTmpDefaultDeger?.length > 0
          ? this.state.MasrafTmpDefaultDeger[0].sirketler
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  MasrafFormPageInit2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectMasrafTmp !== undefined
            ? stateVars.SelectMasrafTmp?.length > 0
              ? stateVars.SelectMasrafTmp[0].id
              : null
            : this.state.SelectMasrafTmp?.length > 0
            ? this.state.SelectMasrafTmp[0].id
            : null
        ),
        true
      )
    ) {
      isErrorOccurred = await this.MasrafFormPageInit_if2();
      if (isErrorOccurred) return true;
    } else {
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masrafform_9450_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        stateVars.SelectMasrafTmp !== undefined
          ? stateVars.SelectMasrafTmp?.length > 0
            ? stateVars.SelectMasrafTmp[0].dosyalar
            : null
          : this.state.SelectMasrafTmp?.length > 0
          ? this.state.SelectMasrafTmp[0].dosyalar
          : null
      ),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormPageInit3_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  MasrafFormPageInit3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      dosyalar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_9450_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafForm/MasrafFormPageInit3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ParseIntoTable = result?.data.parseIntoTable;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormPageInit4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormPageInit4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_2496347 =
      stateVars.UcusSirketleri ?? this.state.UcusSirketleri;
    stateVars.dataSource_2496347 =
      stateVars.UcusSirketleri ?? this.state.UcusSirketleri;
    formVars.masrafform_6966972_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectMasrafTmp !== undefined
        ? stateVars.SelectMasrafTmp?.length > 0
          ? stateVars.SelectMasrafTmp[0].masrafKodu
          : null
        : this.state.SelectMasrafTmp?.length > 0
        ? this.state.SelectMasrafTmp[0].masrafKodu
        : null
    );

    stateVars.dataSource_6966972 =
      stateVars.MasrafCesidiSelectAll ?? this.state.MasrafCesidiSelectAll;
    stateVars.dataSource_6966972 =
      stateVars.MasrafCesidiSelectAll ?? this.state.MasrafCesidiSelectAll;
    formVars.masrafform_2976536_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectMasrafTmp !== undefined
        ? stateVars.SelectMasrafTmp?.length > 0
          ? stateVars.SelectMasrafTmp[0].tutar
          : null
        : this.state.SelectMasrafTmp?.length > 0
        ? this.state.SelectMasrafTmp[0].tutar
        : null
    );

    formVars.masrafform_2912554_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectMasrafTmp !== undefined
        ? stateVars.SelectMasrafTmp?.length > 0
          ? stateVars.SelectMasrafTmp[0].pBr
          : null
        : this.state.SelectMasrafTmp?.length > 0
        ? this.state.SelectMasrafTmp[0].pBr
        : null
    );

    stateVars.dataSource_2912554 =
      stateVars.ParaBirimiListe ?? this.state.ParaBirimiListe;
    stateVars.dataSource_2912554 =
      stateVars.ParaBirimiListe ?? this.state.ParaBirimiListe;
    formVars.masrafform_1620778_value = ReactSystemFunctions.toString(
      this,
      stateVars.SelectMasrafTmp !== undefined
        ? stateVars.SelectMasrafTmp?.length > 0
          ? stateVars.SelectMasrafTmp[0].aciklama
          : null
        : this.state.SelectMasrafTmp?.length > 0
        ? this.state.SelectMasrafTmp[0].aciklama
        : null
    );

    stateVars.dataSource_87024 =
      stateVars.ParseIntoTable ?? this.state.ParseIntoTable;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  MasrafFormComponent_968274_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.MasrafFormComponent_262374_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafFormComponent_672761_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.UploadFile = (
      (await ReactSystemFunctions.uploadFilesWithInfo("")) as any
    ).data;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormComponent_672761_onClick1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  MasrafFormComponent_672761_onClick_foreach1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MasrafFormComponent_672761_onClick_foreach11_();
        resolve();
      });
    });
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };
  MasrafFormComponent_672761_onClick_foreach1f1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "68ebefa5_37b0_dc8d_0b26_9cedb6bdf63d_notify",
        this.defaultML,
        "Dosya yüklenemedi"
      ),
      ReactSystemFunctions.convertToTypeByName("default", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  MasrafFormComponent_672761_onClick_foreach11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(this, this.ForEach3?.size),
        "0"
      )
    ) {
      isErrorOccurred =
        await this.MasrafFormComponent_672761_onClick_foreach1f1();
      if (isErrorOccurred) return true;
    } else {
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MasrafFormComponent_672761_onClick_foreach12_();
        resolve();
      });
    });
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };
  MasrafFormComponent_672761_onClick_foreach12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      DosyaAdi_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach3?.name),
        "string"
      ),
      Dosya_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.ForEach3?.data),
        "string"
      ),
      Id_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, stateVars.NewGuid),
        "Guid"
      ),
      EklemeZamani_1: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      Ekleyen_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      Degistiren_1: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.getMyUsername(),
        "string"
      ),
      DegistirmeZamani_1: ReactSystemFunctions.convertToTypeByName(
        moment().format("YYYY-MM-DDTHH:mm:ss"),
        "Date"
      ),
      s1_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_9450_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      s2_2: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(this, stateVars.NewGuid),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafForm/MasrafFormComponent_672761_onClick_foreach12_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.NewGuid = result?.data.newGuid;
    stateVars.SaveRecord_1 = result?.data.saveRecord_1;
    stateVars.Concat = result?.data.concat;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.MasrafFormComponent_672761_onClick_foreach13_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormComponent_672761_onClick_foreach13_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masrafform_9450_value",
        "string"
      ),
      ReactSystemFunctions.toString(this, this.state.Concat),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafFormComponent_672761_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    if (ReactSystemFunctions.value(this, this.state.UploadFile)?.length) {
      for (let item of ReactSystemFunctions.value(
        this,
        this.state.UploadFile
      )) {
        this.ForEach3 = item;
        await this.MasrafFormComponent_672761_onClick_foreach1();
      }
    }

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormComponent_672761_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  MasrafFormComponent_672761_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dosyalar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_9450_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafForm/MasrafFormComponent_672761_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ParseIntoTable = result?.data.parseIntoTable;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormComponent_672761_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormComponent_672761_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_87024 =
      stateVars.ParseIntoTable ?? this.state.ParseIntoTable;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafFormComponent_792946_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "masrafform_87024_value", "id"),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafForm/MasrafFormComponent_792946_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DosyaGetir = result?.data.dosyaGetir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormComponent_792946_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormComponent_792946_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masrafform_524940_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        stateVars.DosyaGetir !== undefined
          ? stateVars.DosyaGetir?.length > 0
            ? stateVars.DosyaGetir[0].dosya
            : null
          : this.state.DosyaGetir?.length > 0
          ? this.state.DosyaGetir[0].dosya
          : null
      ),
      null,
      false
    );
    stateVars.ChangeVisibilityOf =
      await ReactSystemFunctions.changeVisibilityOf(
        this,
        ReactSystemFunctions.convertToTypeByName(
          "isComp524940Visible",
          "string"
        ),
        ReactSystemFunctions.convertToTypeByName("visible", "string")
      );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafFormComponent_280193_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "masrafform_87024_value", "id"),
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafForm/MasrafFormComponent_280193_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.DosyaGetir = result?.data.dosyaGetir;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormComponent_280193_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormComponent_280193_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.DownloadFile = await ReactSystemFunctions.downloadFile(
      ReactSystemFunctions.toString(
        this,
        stateVars.DosyaGetir !== undefined
          ? stateVars.DosyaGetir?.length > 0
            ? stateVars.DosyaGetir[0].dosya
            : null
          : this.state.DosyaGetir?.length > 0
          ? this.state.DosyaGetir[0].dosya
          : null
      ),
      ReactSystemFunctions.value(this, "masrafform_87024_value", "ad")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafFormComponent_740588_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dosyalar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_9450_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      dosya_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, "masrafform_87024_value", "id"),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafForm/MasrafFormComponent_740588_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.RemoveString = result?.data.removeString;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormComponent_740588_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormComponent_740588_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "masrafform_9450_value",
        "string"
      ),
      ReactSystemFunctions.toString(this, this.state.RemoveString),
      null,
      false
    );

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormComponent_740588_onClick2_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  MasrafFormComponent_740588_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dosyalar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_9450_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafForm/MasrafFormComponent_740588_onClick2_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ParseIntoTable = result?.data.parseIntoTable;

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormComponent_740588_onClick3_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormComponent_740588_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.dataSource_87024 =
      stateVars.ParseIntoTable ?? this.state.ParseIntoTable;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  MasrafFormComponent_262374_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "e580309f_a64c_8406_5526_f703254a1c54_confirmation",
        this.defaultML,
        "Kaydetmeden çıkmak istediğinize emin misiniz?"
      ),
      "poppins",
      "UYARI",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      KuikaAppManager.showSpinner(this);

      stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  MasrafFormComponent_9544_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      dosyalar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_9450_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafForm/MasrafFormComponent_9544_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.ParseIntoMasraf = result?.data.parseIntoMasraf;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormComponent_9544_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormComponent_9544_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "masrafform_6966972_value",
          "value",
          "MasrafCesidiSelectAll",
          "kod",
          ""
        ),
        null
      ),
      message: "This field is required.",
      formName: "masrafform_6966972_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "masrafform_2912554_value",
          "value",
          "ParaBirimiListe",
          "kod",
          ""
        ),
        null
      ),
      message: "This field is required.",
      formName: "masrafform_2912554_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "masrafform_2849291_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required.",
      formName: "masrafform_2849291_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "masrafform_2976536_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required.",
      formName: "masrafform_2976536_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.EditId ?? this.props.screenInputs.editid,
        "Guid"
      ),
      MasrafCesidi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_6966972_value",
            "value",
            "MasrafCesidiSelectAll",
            "kod",
            "ad"
          )
        ),
        "string"
      ),
      MasrafKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_6966972_value",
            "value",
            "MasrafCesidiSelectAll",
            "kod",
            "kod"
          )
        ),
        "string"
      ),
      PBr_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_2912554_value",
            "value",
            "ParaBirimiListe",
            "kod",
            ""
          )
        ),
        "string"
      ),
      SiraNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_2849291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Tutar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_2976536_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Aciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_1620778_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Dosyalar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_9450_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      DosyaAd1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.ParseIntoMasraf?.dosyaAd1
        ),
        "string"
      ),
      DosyaAd2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.ParseIntoMasraf?.dosyaAd2
        ),
        "string"
      ),
      DosyaAd3_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.ParseIntoMasraf?.dosyaAd3
        ),
        "string"
      ),
      DosyaId1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.ParseIntoMasraf?.dosyaId1),
        "Guid"
      ),
      DosyaId2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.ParseIntoMasraf?.dosyaId2),
        "Guid"
      ),
      DosyaId3_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.ParseIntoMasraf?.dosyaId3),
        "Guid"
      ),
      Sirketler_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_2496347_value",
            "value",
            "UcusSirketleri",
            "sirket",
            "sirket"
          )
        ),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectMasrafTmp !== undefined
            ? stateVars.SelectMasrafTmp?.length > 0
              ? stateVars.SelectMasrafTmp[0].id
              : null
            : this.state.SelectMasrafTmp?.length > 0
            ? this.state.SelectMasrafTmp[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MasrafForm/MasrafFormComponent_9544_onClick1_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SaveRecord_2 = result?.data.saveRecord_2;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.MasrafFormComponent_9544_onClick2_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.MasrafFormComponent_9544_onClick2_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormComponent_9544_onClick2_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "masrafform_6966972_value",
          "value",
          "MasrafCesidiSelectAll",
          "kod",
          ""
        ),
        null
      ),
      message: "This field is required.",
      formName: "masrafform_6966972_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "masrafform_2912554_value",
          "value",
          "ParaBirimiListe",
          "kod",
          ""
        ),
        null
      ),
      message: "This field is required.",
      formName: "masrafform_2912554_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "masrafform_2849291_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required.",
      formName: "masrafform_2849291_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });
    validations.push({
      isValid: ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          "masrafform_2976536_value",
          "value",
          "",
          "",
          ""
        ),
        null
      ),
      message: "This field is required.",
      formName: "masrafform_2976536_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.EditId ?? this.props.screenInputs.editid,
        "Guid"
      ),
      MasrafCesidi_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_6966972_value",
            "value",
            "MasrafCesidiSelectAll",
            "kod",
            "ad"
          )
        ),
        "string"
      ),
      MasrafKodu_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_6966972_value",
            "value",
            "MasrafCesidiSelectAll",
            "kod",
            "kod"
          )
        ),
        "string"
      ),
      PBr_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_2912554_value",
            "value",
            "ParaBirimiListe",
            "kod",
            ""
          )
        ),
        "string"
      ),
      SiraNo_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_2849291_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Tutar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_2976536_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      Aciklama_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_1620778_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Dosyalar_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_9450_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      DosyaAd1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.ParseIntoMasraf?.dosyaAd1
        ),
        "string"
      ),
      DosyaAd2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.ParseIntoMasraf?.dosyaAd2
        ),
        "string"
      ),
      DosyaAd3_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          this.state.ParseIntoMasraf?.dosyaAd3
        ),
        "string"
      ),
      DosyaId1_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.ParseIntoMasraf?.dosyaId1),
        "Guid"
      ),
      DosyaId2_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.ParseIntoMasraf?.dosyaId2),
        "Guid"
      ),
      DosyaId3_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(this, this.state.ParseIntoMasraf?.dosyaId3),
        "Guid"
      ),
      Sirketler_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "masrafform_2496347_value",
            "value",
            "UcusSirketleri",
            "sirket",
            "sirket"
          )
        ),
        "string"
      ),
      Id_0_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectMasrafTmp !== undefined
            ? stateVars.SelectMasrafTmp?.length > 0
              ? stateVars.SelectMasrafTmp[0].id
              : null
            : this.state.SelectMasrafTmp?.length > 0
            ? this.state.SelectMasrafTmp[0].id
            : null
        ),
        "Guid"
      ),
      EditId_0_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectMasrafTmp !== undefined
            ? stateVars.SelectMasrafTmp?.length > 0
              ? stateVars.SelectMasrafTmp[0].editId
              : null
            : this.state.SelectMasrafTmp?.length > 0
            ? this.state.SelectMasrafTmp[0].editId
            : null
        ),
        "Guid"
      ),
    };

    if (
      ReactSystemFunctions.isNotEmpty(
        ReactSystemFunctions.value(
          this,
          stateVars.SelectMasrafTmp !== undefined
            ? stateVars.SelectMasrafTmp?.length > 0
              ? stateVars.SelectMasrafTmp[0].id
              : null
            : this.state.SelectMasrafTmp?.length > 0
            ? this.state.SelectMasrafTmp[0].id
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("True", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "MasrafForm/MasrafFormComponent_9544_onClick2_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SaveRecord_3 = result?.data.saveRecord_3;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.MasrafFormComponent_9544_onClick3_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred = await this.MasrafFormComponent_9544_onClick3_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormComponent_9544_onClick3_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.EditId ?? this.props.screenInputs.editid,
        "Guid"
      ),
    };

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "MasrafForm/MasrafFormComponent_9544_onClick3_",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.MasrafTmpToplamGuncelle = result?.data.masrafTmpToplamGuncelle;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.MasrafFormComponent_9544_onClick4_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  MasrafFormComponent_9544_onClick4_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.MasrafFormPageInit();
    }
  }
}
